import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import './components.css';
import './utilities.css';
import './alerts.css';
import {
    initializeKeycloakSso,
    isKeycloakConfigured,
    keycloak,
    startSsoSessionWatch,
} from './shared/auth/lib/keycloakClient';
import { clearAuthSession, isKeycloakBackedSession } from './shared/auth/lib/authSession';
import { authService } from './helpers/services/Auth';

async function bootstrap() {
    // SSO institucional: resuelve tanto el regreso desde Keycloak (hay
    // `code` en la URL) como la detección silenciosa de una sesión ya
    // abierta en otro portal del mismo realm. Se intercambia por el JWT
    // propio ANTES de montar la app para que AuthProvider ya vea la sesión
    // en su primer render (resolveSession solo lee localStorage, sin red).
    try {
        const ssoAuthenticated = await initializeKeycloakSso();

        if (ssoAuthenticated && keycloak.token) {
            await authService.loginWithKeycloak(keycloak.token);
            // A partir de aquí la sesión local vive atada a la sesión SSO:
            // se vigila mientras la pestaña esté abierta.
            startSsoSessionWatch();
        } else if (isKeycloakConfigured() && isKeycloakBackedSession()) {
            // No hay sesión SSO (se cerró en este o en otro sitio del realm)
            // pero sí quedó el JWT propio en localStorage. Sin esto el usuario
            // seguiría dentro hasta que ese JWT expirara por su cuenta:
            // `onAuthLogout` no cubre este caso porque keycloak-js solo lo
            // dispara cuando había un token en memoria que descartar.
            console.warn('La sesión institucional ya no está activa: se cierra la sesión local.');
            clearAuthSession();
        }
    } catch (error) {
        console.error('No fue posible iniciar sesión institucional (SSO):', error);
    }

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <App />
    );
}

bootstrap();
